import { lazy } from "react";
import { Radio } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const sensorsFeature: FeatureDescriptor = {
  id: "sensors",
  flag: "sensors",
  path: "/sensors",
  group: "operate",
  navKey: "nav.sensors",
  icon: Radio,
  element: lazy(() => import("./SensorsPage")),
  scope: { locality: true, days: true },
  subRoutes: [
    {
      path: "/sensors/registry",
      // The registry's status column is window-classified like the map, so the
      // global range applies here too.
      element: lazy(() => import("./SensorRegistryPage")),
      scope: { locality: true, days: true },
    },
    // ":id" is ranked below the static sub-routes by React Router. Detail pages are
    // single-sensor (route-scoped), so no global scope chrome — but their window
    // control reads and writes the global range, so the status shown here is the
    // one the map and registry graded over.
    { path: "/sensors/:id", element: lazy(() => import("./SensorDetailPage")) },
  ],
};
